import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'requirements-dashboard.assignee-bar',
                        },
                      },
                    },
                    span: 4,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'requirements-dashboard.type-bar',
                        },
                      },
                    },
                    span: 4,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'requirements-dashboard.status-bar',
                        },
                      },
                    },
                    span: 4,
                  },
                ],
              },
            },
            height: 320,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'requirements-dashboard.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 600,
          },
        ],
      },
    },
    description:
      'At-a-glance status of every requirement, with drill-down to detail',
    name: 'Requirements',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
